import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './patientSummary.css';

const PatientSummaryDialog = ({ show, onHide, summaryTitle, summaryText }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static" keyboard={false} centered className="patient-summary-modal">
      <Modal.Header closeButton>
        <Modal.Title className="dialog-title">
          Report Summary for <b className="summary-report-name">{summaryTitle}</b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {summaryText!==undefined && summaryText!==null && summaryText!=='' ? <div className="summary-text">{summaryText}</div> : <div className="summary-text text-center fw-bold">No summary available</div>}
        
      </Modal.Body>
      <Modal.Footer>
        <div className="ai-disclaimer-row">
          <div className="ai-disclaimer-content">
            <span className="ai-disclaimer-icon">
              <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
            </span>
            <span className="ai-disclaimer-text">
              <span className="ai-disclaimer-bold">Disclaimer:</span>
              <span className="ai-disclaimer-bold"> This summary was generated by AI and may contain inaccuracies. Please review carefully.</span>
            </span>
          </div>
          <Button className="dialog-close-btn" onClick={onHide}>Close</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PatientSummaryDialog;
